import {ChangeDetectorRef, Component, Inject, NgZone, OnInit, Optional, PLATFORM_ID, Renderer2} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {RESPONSE} from "@nguniversal/express-engine/tokens";
import {Router} from "@angular/router";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'bit-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private title: Title,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: string,
    @Optional() @Inject(RESPONSE) private response: any,
    private renderer: Renderer2, private router: Router,
    @Optional() @Inject('lang') private lang: string
  ) {
    this.title.setTitle($localize`یافت نشد`);
  }

  ngOnInit(): void {
    this.cd.detach();
    if (this.document) {
      const canonical = this.document.querySelector('link[rel="canonical"]');
      if (canonical) {
        if (isPlatformBrowser(this.platformId)) {
          this.renderer.setAttribute(canonical, 'href', window.location.href);
        } else {
          this.renderer.setAttribute(canonical, 'href', environment.domain + this.lang );
        }
      }
    }
    if (!isPlatformBrowser(this.platformId)) {
      this.response.statusCode = 404;

    }
    this.zone.runOutsideAngular(() => {
      const stackContainer = this.document.querySelector('.stack-container') as HTMLDivElement;
      const cardNodes = this.document.querySelectorAll('.card-container');
      const perspecNodes = this.document.querySelectorAll('.perspec');
      const perspec = this.document.querySelector('.perspec');
      const card = this.document.querySelector('.card');

      let counter = stackContainer?.children.length ?? 0;

      //function to generate random number
      const randomIntFromInterval = (min: number, max: number) => {
        return Math.floor(Math.random() * (max - min + 1) + min);
      }

      //after tilt animation, fire the explode animation
      card?.addEventListener('animationend', function () {
        perspecNodes.forEach(function (elem, index) {
          elem.classList.add('explode');
        });
      });

      //after explode animation do a bunch of stuff
      perspec?.addEventListener('animationend', (e: any) => {
        if (e.animationName === 'explode') {
          cardNodes.forEach((elem: any, index) => {

            //add hover animation class
            elem.classList.add('pokeup');

            //add event listner to throw card on click
            elem.addEventListener('click', () => {
              let updown = [800, -800]
              let randomY = updown[Math.floor(Math.random() * updown.length)];
              let randomX = Math.floor(Math.random() * 1000) - 1000;

              elem.style.transform = `translate(${randomX}px, ${randomY}px) rotate(-540deg)`
              elem.style.transition = "transform 1s ease, opacity 2s";
              elem.style.opacity = "0";
              counter--;
              if (counter === 0) {
                stackContainer.style.width = "0";
                stackContainer.style.height = "0";
              }
            });

            //generate random number of lines of code between 4 and 10 and add to each card
            let numLines = randomIntFromInterval(5, 10);

            //loop through the lines and add them to the DOM
            for (let index = 0; index < numLines; index++) {
              let lineLength = randomIntFromInterval(25, 97);
              const node = this.document.createElement("li");
              node.classList.add('node-' + index);
              elem.querySelector('.code ul').appendChild(node).setAttribute('style', '--linelength: ' + lineLength + '%;');

              //draw lines of code 1 by 1
              if (index == 0) {
                elem.querySelector('.code ul .node-' + index).classList.add('writeLine');
              } else {
                elem.querySelector('.code ul .node-' + (index - 1)).addEventListener('animationend', () => {
                  elem.querySelector('.code ul .node-' + index).classList.add('writeLine');
                });
              }
            }
          });
        }
      });
    })
  }

}
